module.exports = __webpack_public_path__ + "img/gl.b3223ee1.svg";